export default __webpack_public_path__ + "static/roadmap-11bf3be5884a8ba153e0803791c5cc81.png";